import { analytics } from '@muse/analytics'
import { getRealTimeParams } from '@muse-web/analytics'
import { getGlobalParams } from './getGlobalParams'
import { getSessionId } from './getSessionId'
import { logger } from './logger'
import { createHttpTransport, createShareHttpTransport } from './transport'

export const configureAnalytics = () => {
  const transport = createHttpTransport()

  analytics.configure({
    // getRealTimeParams,
    transport,
    getSessionId,
    logger,
  })

  analytics.setGlobalParams({
    // ...getGlobalParams(),
  })

  analytics.setUnifiedId('zendesk-publisher-app')
}

export const configureShareAnalytics = () => {
  const transport = createShareHttpTransport()

  analytics.configure({
    transport,
    getSessionId,
    logger,
  })

  analytics.setGlobalParams({})

  analytics.setUnifiedId('zendesk-publisher-app')
}

export { analytics }
export { AnalyticsProvider } from './AnalyticsProvider'
export { ShareAnalyticsProvider } from './ShareAnalyticsProvider'
export { useAnalytics } from './hooks'
export { deepKeysToSnakeCase, keyToSnakeCase } from './helpers'
